import { styled } from 'styled-components';
import { Button } from '../../Button';
export const AlertBannerDismissButton = styled(Button).withConfig({
  displayName: "AlertBannerDismissButton",
  componentId: "asurion-ui-react__sc-53j66u-0"
})(["background-color:transparent;border-color:transparent;border-width:0.25rem;color:currentColor;margin:0;padding:0.75rem;&:not(:disabled):hover,&:not(:disabled):active{background-color:transparent;border-color:transparent;color:currentColor;}"]);